
import { getParams } from '~/plugins/product'

export default {
  name: 'ProductGrid',
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  methods: { getParams }
}
